import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";

const ImpressumPage = () => {
  return (
    <div data-testid="impressum-page" className="min-h-screen bg-stone-50">
      <Navigation />
      <main className="pt-24 pb-16">
        <div className="container-custom">
          <Link 
            to="/" 
            data-testid="back-to-home"
            className="inline-flex items-center gap-2 text-emerald-600 hover:text-emerald-700 mb-8 font-medium transition-colors"
          >
            <ArrowLeft className="w-4 h-4" />
            Zurück zur Startseite
          </Link>
          
          <div className="glass-card rounded-3xl p-8 md:p-12 max-w-4xl">
            <h1 className="text-3xl md:text-4xl font-bold text-slate-900 mb-8 font-[Outfit]">
              Impressum
            </h1>
            
            <div className="space-y-8 text-slate-600 leading-relaxed">
              <section>
                <h2 className="text-xl font-semibold text-slate-800 mb-3 font-[Outfit]">
                  Angaben gemäß § 5 TMG
                </h2>
                <p>
                  Jennifer Laak<br />
                  Thermomix® Repräsentantin<br />
                  Franz-Hartz-Straße 17<br />
                  47839 Krefeld
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-slate-800 mb-3 font-[Outfit]">
                  Kontakt
                </h2>
                <p>
                  Telefon: 0172 1697433<br />
                  Telefax: 03212 9636633<br />
                  E-Mail: jennifer-laak@gmx.de
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-slate-800 mb-3 font-[Outfit]">
                  Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV
                </h2>
                <p>
                  Jennifer Laak<br />
                  Franz-Hartz-Straße 17<br />
                  47839 Krefeld
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-slate-800 mb-3 font-[Outfit]">
                  EU-Streitschlichtung
                </h2>
                <p>
                  Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:{" "}
                  <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer" className="text-emerald-600 hover:underline">
                    https://ec.europa.eu/consumers/odr
                  </a>
                </p>
                <p className="mt-2">
                  Unsere E-Mail-Adresse finden Sie oben im Impressum.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-slate-800 mb-3 font-[Outfit]">
                  Verbraucherstreitbeilegung / Universalschlichtungsstelle
                </h2>
                <p>
                  Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer 
                  Verbraucherschlichtungsstelle teilzunehmen.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-slate-800 mb-3 font-[Outfit]">
                  Haftung für Inhalte
                </h2>
                <p>
                  Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten 
                  nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als 
                  Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde 
                  Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige 
                  Tätigkeit hinweisen. Verpflichtungen zur Entfernung oder Sperrung der Nutzung von 
                  Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche 
                  Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung 
                  möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese 
                  Inhalte umgehend entfernen.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-slate-800 mb-3 font-[Outfit]">
                  Haftung für Links
                </h2>
                <p>
                  Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen 
                  Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. 
                  Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der 
                  Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf 
                  mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung 
                  nicht erkennbar. Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne 
                  konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von 
                  Rechtsverletzungen werden wir derartige Links umgehend entfernen.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-slate-800 mb-3 font-[Outfit]">
                  Urheberrecht
                </h2>
                <p>
                  Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen 
                  dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art 
                  der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen 
                  Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind 
                  nur für den privaten, nicht kommerziellen Gebrauch gestattet. Soweit die Inhalte auf dieser 
                  Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet. 
                  Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine 
                  Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei 
                  Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.
                </p>
              </section>

              <section className="pt-4 border-t border-stone-200">
                <p className="text-sm text-slate-500 italic">
                  Diese Website wird von Jennifer Laak als selbstständige Thermomix® Repräsentantin betrieben 
                  und ist kein offizielles Angebot der Vorwerk Gruppe. Die Marke Thermomix® ist eine 
                  eingetragene Marke der Vorwerk International & Co. KmG.
                </p>
              </section>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default ImpressumPage;
